module.exports = __webpack_public_path__ + "img/banner.3ad22c12.png";